import { render } from "./Footer.vue?vue&type=template&id=14217b12"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=14217b12&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script